import { render, staticRenderFns } from "./EditReports.vue?vue&type=template&id=44bb94c4&scoped=true&"
import script from "./EditReports.vue?vue&type=script&lang=js&"
export * from "./EditReports.vue?vue&type=script&lang=js&"
import style0 from "./EditReports.vue?vue&type=style&index=0&id=44bb94c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb94c4",
  null
  
)

export default component.exports